import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import React from "react";
import Slider from "react-slick";
import "../styles/Testimonial.css"; 

const Testimonial = () => {
  const images = [
    "Testimonials-1.webp",
    "Testimonials-3.webp",
    "Testimonials-4.webp",
    "Testimonials-5.webp",
    "Testimonials-6.webp",
    "Testimonials-7.webp",
    "Testimonials-8.webp",
    "Testimonials-9.webp",
    "Testimonials-10.webp",
    "Testimonials-11.webp",
    "Testimonials-12.webp",
    "Testimonials-13.webp",
    "Testimonials-14.webp",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 360, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <>
    <section className="success-stories-section" id="success-stories">
        {/* Title Section */}
        <div className="success-stories-header">
          <h2>
            <span className="highlight">Mahadev Book :</span> Real{" "}
            <span className="highlight">Stories,</span> Real Wins from Our{" "}
            <span className="highlight">Players</span>
          </h2>
          <p>
          Mahadev Book Official has carved a strong reputation in the online gaming world as a reliable and trusted platform. With countless verified success stories and positive player feedback, it’s become a go-to destination for those seeking both excitement and credibility. The platform combines a diverse range of thrilling games with advanced features that support safe and responsible gaming. Backed by transparent practices and a growing community of loyal users, Mahadev Book continues to stand out as a secure, rewarding, and highly respected name in the competitive world of online gaming.
          </p>
        </div>

        {/* Carousel Section */}
        <div className="success-stories-gallery">
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Success story ${index + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
    </section>
     <section className="testimonialcontact">
     <a
     href={ContactLink}
     target="_blank"
     rel="noopener noreferrer"
     className="contact-btn testimonial-btn"
   >
     Contact Us @ 8888568888
   </a>
   <a
     href={whatsappLink}
     target="_blank"
     rel="noopener noreferrer"
     className="contact-btn testimonial-btn"
   >
     WhatsApp Us @ 8888988880
   </a>
     </section>
   </>
  );
};

export default Testimonial;
